import React from "react";
import type { CSSProperties } from "react";
import { PieChart, Cell, Pie } from "recharts";

type DonutChartProps = {
  daysLeft?: number;
  totalDays?: number;
  className?: string;
  style?: CSSProperties;
  width?: number;
  height?: number;
};

const DonutChart: React.FC<DonutChartProps> = ({
  daysLeft = 2,
  totalDays = 30,
  className,
  style,
  width = 28,
  height = 28,
}) => {
  const data = [
    { name: "Days Passed", value: totalDays - daysLeft },
    { name: "Days Left", value: daysLeft },
  ];

  const COLORS = ["#604C4C", "#FFB380"];

  return (
    <PieChart width={width} height={height} className={className} style={style}>
      <Pie
        data={data}
        dataKey="value"
        cx="50%"
        cy="50%"
        outerRadius={width / 2}
        startAngle={90}
        endAngle={-270}
        stroke="none" 
      >
        {data.map((_, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index]} />
        ))}
      </Pie>
    </PieChart>
  );
};

export default DonutChart;
